import controller from './developer-settings.controller';

const template = require('./developer-settings.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/developer-settings/developer-settings.component.js